import { EllipsisVertical } from 'lucide-react';
import { forwardRef } from 'react';

import { toSlug } from '@crossnokaye/ux-common';
import {
  Button,
  MobileMenu,
  MobileMenuContent,
  MobileMenuTrigger,
  SimpleStackNavigator,
  SimpleStackScreen,
} from '@crossnokaye/ux-common/ckds';

import { JUMP_TO_MENU_ID } from './constants';
import { JumpToEquipmentScreen } from './jump-to-equipment-screen';
import { JumpToSectionScreen } from './jump-to-section-screen';
import { useJumpToEquipment } from '../useJumpToEquipment';

interface JumpToEquipmentMobileMenuProps {
  className?: string;
}

export const JumpToEquipmentMobileMenu = forwardRef<HTMLDivElement, JumpToEquipmentMobileMenuProps>(
  (props, ref) => {
    const jumpToEquipment = useJumpToEquipment();
    const { sections } = jumpToEquipment;

    return (
      <div ref={ref} {...props}>
        <MobileMenu id={JUMP_TO_MENU_ID}>
          <MobileMenuTrigger asChild>
            <Button variant={'tier3'} shape={'square'}>
              <EllipsisVertical className="w-5 h-5" />
            </Button>
          </MobileMenuTrigger>
          <MobileMenuContent className="w-full">
            <SimpleStackNavigator initialScreen="jump-to-section-screen">
              <SimpleStackScreen id="jump-to-section-screen">
                <JumpToSectionScreen sections={sections ?? []} />
              </SimpleStackScreen>

              {sections?.map((section) => {
                const id = `jump-to-equipment-screen-${toSlug(section.name)}`;
                return (
                  <SimpleStackScreen key={id} id={id}>
                    <JumpToEquipmentScreen {...jumpToEquipment} section={section} />
                  </SimpleStackScreen>
                );
              })}
            </SimpleStackNavigator>
          </MobileMenuContent>
        </MobileMenu>
      </div>
    );
  }
);
